/* Halo PDP behaviour. Extracted from product-halo-lytt.liquid during the
   section split. Loaded once by halo-pdp-buybox; the guard below makes a
   second include harmless, and every cross-section lookup is null-checked
   so any section can be reordered or removed without breaking the rest. */
(function () {
  if (window.__haloPdpInit) return;
  window.__haloPdpInit = true;

document.addEventListener('DOMContentLoaded', function () {
  const featureDetails = {
    'stress-insights': { title: 'Stress Insights', description: 'Growing up comes with unique pressures, from rigorous school exams to competitive sports and shifting social dynamics. Halo Lytt continuously monitors physiological stress markers quietly in the background without causing screen-induced anxiety.', highlights: ['Monitors physiological stress markers continuously', 'Identifies hidden stress patterns'] },
    'sleep-insights': { title: 'Sleep Insights', description: 'Quality rest is the foundation of healthy brain development, emotional regulation, and physical growth for children and teenagers. The band automatically tracks complete sleep cycles-including deep, light, and REM stages-along with overnight awakenings.', highlights: ['Tracks deep, light, and REM sleep stages', 'Monitors overnight awakenings'] },
    'temperature': { title: 'Temperature', description: 'Tracking skin temperature trends can help parents catch early signs that something has changed. The app learns your child\'s usual range and shows when their readings move outside it.', highlights: ['Learns your child\'s usual temperature range', 'Shows when readings move outside it'] },
    'heart-rate': { title: 'Heart Rate', description: 'Frequent heart rate readings through the day and night give you a reliable baseline for your child\'s activity and effort. You can see how hard they worked and how quickly they settled afterwards.', highlights: ['Frequent readings, day and night', 'A reliable baseline for your child'] },
    'recovery': { title: 'Recovery', description: 'See how well your child bounces back after sports, school, and busy days, so you can tell when they need a rest day.', highlights: ['Shows how well they recover after busy days', 'Helps you spot when they need a rest day'] },
    'step-counts': { title: 'Step Counts', description: 'The foundation of daily activity is tracked automatically, logging every step your child takes throughout their busy day.', highlights: ['Measures every move automatically, every day', 'Helps reach your daily activity goals'] },
    'calories': { title: 'Calories', description: 'Monitoring daily energy expenditure is vital for ensuring highly active teenagers are receiving the proper nutrition to fuel their growth.', highlights: ['Tracks daily energy expenditure', 'Balances nutrition with physical output'] },
    'walking': { title: 'Walking', description: 'The device recognizes the duration and exact intensity of your child\'s daily walking commutes and routines, so you know they are staying consistently active.', highlights: ['Tracks duration and intensity', 'Promotes consistent active routines'] },
    'running': { title: 'Running', description: 'The smart accelerometer tracks your child\'s active running sessions, providing reliable metrics on duration and intensity while on the field or tracking their fitness.', highlights: ['Smart accelerometer tracking', 'Provides duration and intensity metrics'] },
    'football': { title: 'Football', description: 'Track football training and matches. See how long your child played, how hard they worked, and how their heart rate rose and came back down.', highlights: ['Playing time and intensity', 'Heart rate and calories for the session'] },
    'cricket': { title: 'Cricket', description: 'A day of cricket mixes long, quiet spells in the field with short bursts of running and bowling. Halo Lytt records the whole session, so you can see how active your child really was.', highlights: ['Records long sessions and short bursts', 'Active time, heart rate and calories'] },
    'track-field': { title: 'Track & Field', description: 'Sprints, distance runs and jumps each ask for a different kind of effort. See the intensity and heart rate behind every training session, and how fast your child recovers between events.', highlights: ['Intensity and heart rate for each session', 'Recovery between sprints and events'] },
    'other-sports': { title: 'Other Sports', description: 'Halo Lytt works the same way for basketball, tennis, cycling, martial arts, dance and other active sports. You see how long your child was active, how hard they worked and what their heart rate did.', highlights: ['Works across other active sports', 'Active time, intensity and heart rate'] },
    'family-tower': { title: 'Family Tower', description: 'The intuitive in-app dashboard consolidates and clearly displays the daily wellness and activity data for all family members wearing the band, right in one unified place.', highlights: ['Consolidates daily wellness and activity data', 'Displays all family members in one place'] },
    'ghost-mode': { title: 'Ghost Mode', description: 'Ghost Mode gives older kids a private window. While it is on, their location cannot be seen and live readings are paused. The band keeps recording in the background, so their wellness history stays complete.', highlights: ['Location is hidden while it is on', 'Keeps recording wellness data'] },
    'simple-scores': { title: 'Simple Scores', description: 'The app skips complex graphs and medical jargon and turns your child\'s readings into simple scores. Each vital score runs from 1 to 10, with 10 being the best. A high score means a good day. A low score is a sign that something needs more attention.', highlights: ['Halo Score: how yesterday went overall', 'Consistency Score: how steady your child\'s health patterns are'] },
    'sensors': { title: 'Sensors', description: 'Advanced, zero-distraction monitoring technology is housed within a band so lightweight and ergonomic that kids will quickly forget they are wearing it. These durable components are specifically calibrated for smaller wrists, ensuring highly accurate data collection regardless of how much they run, jump, or play.', highlights: ['Lightweight and ergonomic for smaller wrists', 'Zero-distraction monitoring technology', 'Durable and accurate for active kids'] },
    'battery': { title: 'Battery', description: 'We engineered the Halo Lytt with an ultra-efficient power system designed to go the distance. The device is built to last for more than 30 days on a single charge, completely taking away the constant worry and hassle of having to plug it in every night. This remarkable battery life means the band seamlessly blends into your child\'s schedule, resulting in continuous, reliable health monitoring month after month.', highlights: ['Over 30 days on a single charge', 'No nightly charging hassle', 'Continuous, reliable health monitoring'] },
    'dimensions-fit': { title: 'Dimensions & Fit', description: 'The extremely compact module measures just 18×36×9mm, while the highly durable, stretchy, woven elastic bands reliably fit wrist circumferences ranging broadly from 130mm to 190mm.', highlights: ['Compact module: 18×36×9mm', 'Highly durable, stretchy elastic bands', 'Fits wrist circumferences: 130mm to 190mm'] },
    'materials-design': { title: 'Materials & Design', description: 'Halo Lytt is made from child-safe materials. The core module sits in a stainless steel case with a matte finish, and the SoftWeave band is soft, breathable and hypoallergenic, so it stays comfortable on young skin through a full day of wear and sweaty play.', highlights: ['Child-safe materials', 'Stainless steel case, matte finish', 'Soft, breathable, hypoallergenic SoftWeave band'] },
    'connectivity-syncing': { title: 'Connectivity & Syncing', description: 'The tracker seamlessly synchronizes with the companion app via energy-efficient Bluetooth Low Energy (BLE), ensuring a secure, steady connection up to 30 feet from the device.', highlights: ['Synchronizes via Bluetooth Low Energy (BLE)', 'Ensures a secure, steady connection', 'Range up to 30 feet from the device'] },
    'durability-power': { title: 'Durability & Power', description: 'Halo Lytt handles heavy rain and showers. The battery lasts more than 30 days on a single charge, and a full recharge takes about 2 hours.', highlights: ['Handles heavy rain and showers', 'More than 30 days per charge', 'Full recharge in about 2 hours'] },
    'internal-hardware': { title: 'Internal Hardware', description: 'Hidden beneath its subtle exterior, the tracker houses a highly precise 3-axis accelerometer, advanced optical heart rate sensors, an accurate temperature scanner, and a haptic vibration motor for completely silent alarms.', highlights: ['Precise 3-axis accelerometer', 'Advanced optical heart rate sensors', 'Accurate temperature scanner', 'Haptic vibration motor for silent alarms'] },
    'core-tracker': { title: 'Halo Lytt Core Tracker', description: 'The central intelligence unit of the HALO system. This highly advanced, screen-free sensor capsule discreetly houses all the biometric tracking hardware and securely snaps into the comfortable wristbands.', highlights: ['Central intelligence unit', 'Houses all biometric tracking hardware'] },
    'comfort-straps': { title: '2x Comfort Straps', description: 'Two exceptionally soft, deeply breathable woven elastic nylon bands designed specifically for all-day continuous wear. They slip on effortlessly without any stiff buckles and are fully machine washable for quick hygiene.', highlights: ['Two soft, breathable woven elastic nylon bands', 'Machine washable for quick hygiene'] },
    'charging-cable': { title: 'Magnetic Charging Cable', description: 'A proprietary USB-A cable with a magnetic pogo-pin connector that snaps onto the back of the core tracker. It gives a full charge in about 2 hours.', highlights: ['Proprietary USB-A to magnetic pogo-pin cable', 'Securely snaps onto the core tracker'] },
    'carry-pouch': { title: 'Velvet Carry Pouch', description: 'A premium, ultra-soft travel and storage pouch to safely keep your band, spare straps, and charging cable meticulously organized both at home and while actively on the move.', highlights: ['Premium, ultra-soft travel and storage pouch', 'Keeps band and accessories organized'] },
    'welcome-greeting': { title: 'Welcome Greeting', description: 'A beautifully designed quick-start guide card securely enclosing your unique digital activation key, providing immediate access to the full suite of the Halo Companion App for parents.', highlights: ['Quick-start guide card', 'Provides immediate access to Halo Companion App'] },
    'certifications': { title: 'Certifications', description: 'Halo Lytt is CE, FCC, and RoHS compliant the same electrical and materials-safety standards required for any device sold in Europe.', highlights: ['CE certified', 'FCC certified', 'RoHS compliant'] },
    'sensor-type': { title: 'Sensor Type', description: 'Halo Lytt uses green and red LED (PPG) optical sensing the same method used in Apple Watch, Whoop, and Oura. There\'s no infrared, no UV, and no lasers involved.', highlights: ['Green + Red LED (PPG) optical sensor', 'No infrared, UV, or laser components'] },
    'data-residency': { title: 'Data Residency', description: 'Your child\'s data is stored on secure servers in Ireland, governed by EU data-protection law, and encrypted in transit and at rest. We never sell it or share it with advertisers.', highlights: ['Servers located in Ireland (EU)', 'Encrypted in transit & at rest', 'Never sold or shared with advertisers'] },
    'warranty-coverage': { title: 'Warranty', description: 'Every Halo Lytt is backed by a 1-year limited hardware warranty covering manufacturing and workmanship defects under normal use.', highlights: ['1-year limited hardware warranty', 'Covers manufacturing defects under normal use'] }
  };

  const section = document.getElementById('product-section');
  const variantCards = document.querySelectorAll('.halo-variant-card');
  const formVariantInput = document.getElementById('halo-variant-id');
  const mainPrice = document.getElementById('halo-main-price');
  const buyBtnPrice = document.getElementById('halo-buy-price');
  const categoryTabs = document.querySelectorAll('.halo-cat-tab');
  const featureChips = document.querySelectorAll('#halo-feature-chips .halo-chip');
  const allChips = document.querySelectorAll('.halo-chip');
  const bannerBuyBtn = document.getElementById('halo-banner-buy-btn');

  // Part B extra Add-to-Cart surfaces (final CTA + sticky bar)
  const finalVariantInput = document.getElementById('halo-final-variant-id');
  const finalPrice = document.getElementById('halo-final-price');
  const finalBtnPrice = document.getElementById('halo-final-btn-price');
  const stickyPrice = document.getElementById('halo-sticky-price');
  const finalBtn = document.getElementById('halo-final-btn');
  const stickyBtn = document.getElementById('halo-sticky-btn');
  const stickyBar = document.getElementById('halo-pb-sticky');
  const finalSection = document.getElementById('halo-pb-final-section');

  // Carousel Logic
  const track = document.getElementById('halo-carousel-track');
  const prevBtn = document.getElementById('halo-carousel-prev');
  const nextBtn = document.getElementById('halo-carousel-next');
  const dotsContainer = document.getElementById('halo-carousel-dots');
  const allSlides = document.querySelectorAll('.halo-carousel-slide');
  const viewport = document.getElementById('halo-carousel-viewport');
  let currentSlideIndex = 0;
  let autoPlayInterval;

  function getVisibleSlides() {
      return Array.from(allSlides).filter(slide => slide.style.display !== 'none');
  }

  function updateCarousel(instant = false) {
      if (!track) return;
      const visibleSlides = getVisibleSlides();
      if (visibleSlides.length === 0) return;
      
      if (currentSlideIndex >= visibleSlides.length) currentSlideIndex = 0;
      if (currentSlideIndex < 0) currentSlideIndex = visibleSlides.length - 1;
      
      track.style.transition = instant ? 'none' : 'transform 0.4s ease-in-out';
      track.style.transform = `translateX(-${currentSlideIndex * 100}%)`;
      
      const dots = dotsContainer.querySelectorAll('.halo-carousel-dot');
      dots.forEach((dot, index) => {
          if (index === currentSlideIndex) dot.classList.add('active');
          else dot.classList.remove('active');
      });
  }

  function nextSlide() {
      currentSlideIndex++;
      updateCarousel();
  }

  function prevSlide() {
      currentSlideIndex--;
      updateCarousel();
  }

  function startAutoPlay() {
      stopAutoPlay();
      autoPlayInterval = setInterval(nextSlide, 3000);
  }

  function stopAutoPlay() {
      if (autoPlayInterval) clearInterval(autoPlayInterval);
  }

  if (prevBtn) prevBtn.addEventListener('click', () => { prevSlide(); startAutoPlay(); });
  if (nextBtn) nextBtn.addEventListener('click', () => { nextSlide(); startAutoPlay(); });
  
  if (viewport) {
      viewport.addEventListener('mouseenter', stopAutoPlay);
      viewport.addEventListener('mouseleave', startAutoPlay);
      startAutoPlay();
  }

  // Touch swipe support (mobile: swipe left/right to change image)
  if (viewport) {
      let touchStartX = 0;
      let touchStartY = 0;
      let touchDeltaX = 0;
      let isSwiping = false;

      viewport.addEventListener('touchstart', (e) => {
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
          touchDeltaX = 0;
          isSwiping = true;
          stopAutoPlay();
      }, { passive: true });

      viewport.addEventListener('touchmove', (e) => {
          if (!isSwiping) return;
          touchDeltaX = e.touches[0].clientX - touchStartX;
      }, { passive: true });

      viewport.addEventListener('touchend', () => {
          if (!isSwiping) return;
          isSwiping = false;
          const SWIPE_THRESHOLD = 40;
          if (touchDeltaX <= -SWIPE_THRESHOLD) {
              nextSlide();
          } else if (touchDeltaX >= SWIPE_THRESHOLD) {
              prevSlide();
          }
          startAutoPlay();
      });
  }

  function filterImages(variantTitle) {
      const selectedTitle = variantTitle.toLowerCase().trim();
      let visibleCount = 0;
      
      allSlides.forEach(slide => {
          const altText = (slide.dataset.variantAlt || '').toLowerCase().trim();
          let isMatch = false;
          
          if (!altText) {
              isMatch = true;
          } else {
              const altWords = altText.replace(/[^a-z0-9]/g, ' ').split(/\s+/).filter(w => w.length > 2);
              if (altWords.length > 0) {
                  isMatch = altWords.every(word => selectedTitle.includes(word));
              } else {
                  isMatch = selectedTitle.includes(altText);
              }
          }
          
          if (isMatch) {
              slide.style.display = '';
              visibleCount++;
          } else {
              slide.style.display = 'none';
          }
      });
      
      if (dotsContainer) {
          dotsContainer.innerHTML = '';
          for (let i = 0; i < visibleCount; i++) {
              let dot = document.createElement('button');
              dot.className = 'halo-carousel-dot';
              dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
              if (i === 0) dot.classList.add('active');
              dot.addEventListener('click', () => {
                  currentSlideIndex = i;
                  updateCarousel();
                  startAutoPlay();
              });
              dotsContainer.appendChild(dot);
          }
      }
      
      currentSlideIndex = 0;
      updateCarousel(true);
  }
  
  const initialActiveCard = document.querySelector('.halo-variant-card.active');
  if (initialActiveCard) {
      filterImages(initialActiveCard.dataset.variantTitle);
  }

  // Stock state has to follow the selected variant. Liquid renders the
  // correct state for the variant the page loads with; without this the
  // button would keep that state after switching colour and could offer a
  // sold-out variant, which then fails at checkout.
  // Resolved on each call: some of these buttons are declared further down
  // this file, so capturing them here would hit the temporal dead zone.
  function getBuyButtons() {
    return [
      document.getElementById('halo-buy-btn'),
      document.getElementById('halo-final-btn'),
      document.getElementById('halo-sticky-btn'),
      document.getElementById('halo-banner-buy-btn')
    ];
  }

  function syncStockState(card) {
    if (!card) return;
    const available = card.dataset.variantAvailable !== 'false';

    getBuyButtons().forEach(btn => {
      if (!btn) return;
      btn.disabled = !available;
      const labelEl = btn.querySelector('[data-halo-buy-label]');
      if (labelEl) {
        const available_label = btn.dataset.labelAvailable || 'Add to Cart';
        const soldout_label = btn.dataset.labelSoldout || 'Sold out';
        labelEl.textContent = available ? available_label : soldout_label;
      }
      const amountEl = btn.querySelector('.halo-buy-amount');
      if (amountEl) amountEl.hidden = !available;
    });
  }

  variantCards.forEach(card => {
    card.addEventListener('click', function() {
      if (this.dataset.variantAvailable === 'false') return;

      variantCards.forEach(c => c.classList.remove('active'));
      this.classList.add('active');

      const newId = this.dataset.variantId;
      if (formVariantInput) formVariantInput.value = newId;

      if (mainPrice) mainPrice.textContent = this.dataset.variantPrice;

      // Compare-at follows the selected variant. Empty data attribute means
      // this variant is not discounted, so both elements hide rather than
      // showing an empty strikethrough or a "Save" with no amount.
      var wasEl = document.querySelector('[data-halo-price-was]');
      var saveEl = document.querySelector('[data-halo-price-save]');
      var promoEl = document.querySelector('[data-halo-promo]');
      var wasVal = this.dataset.variantCompare;
      var saveVal = this.dataset.variantSaving;
      var onSale = !!(wasVal && saveVal);
      if (wasEl) {
        var wv = wasEl.querySelector('[data-halo-price-was-value]');
        if (wv) wv.textContent = wasVal || '';
        wasEl.hidden = !onSale;
      }
      if (saveEl) {
        var sv = saveEl.querySelector('[data-halo-price-save-value]');
        if (sv) sv.textContent = saveVal || '';
        saveEl.hidden = !onSale;
      }
      if (promoEl) promoEl.hidden = !onSale;
      if (buyBtnPrice) buyBtnPrice.textContent = this.dataset.variantPrice;

      // keep Part B Add-to-Cart surfaces in sync
      if (finalVariantInput) finalVariantInput.value = newId;
      if (finalPrice) finalPrice.textContent = this.dataset.variantPrice;
      if (finalBtnPrice) finalBtnPrice.textContent = this.dataset.variantPrice;
      if (stickyPrice) stickyPrice.textContent = this.dataset.variantPrice;

      window.history.replaceState({}, '', window.location.pathname + '?variant=' + newId);

      syncStockState(this);
      filterImages(this.dataset.variantTitle);
    });
  });

  const thumbnailsWrap = document.querySelector('.halo-thumbnails');
  const heroImage = document.querySelector('.halo-hero-image');
  if (thumbnailsWrap) {
    const thumbBtns = thumbnailsWrap.querySelectorAll('.halo-thumb-btn');
    thumbBtns.forEach(btn => {
      btn.addEventListener('click', function() {
        thumbBtns.forEach(b => b.classList.remove('active'));
        this.classList.add('active');
        
        const newUrl = this.dataset.imageUrl;
        if (heroImage && newUrl) {
          heroImage.classList.add('fade-out');
          setTimeout(() => { heroImage.src = newUrl; heroImage.classList.remove('fade-out'); }, 150);
        }
      });
    });
  }

  categoryTabs.forEach(tab => {
    tab.addEventListener('click', function() {
      categoryTabs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      const filterCat = this.dataset.category;
      featureChips.forEach(chip => {
        if (filterCat === 'All') {
          chip.style.display = '';
        } else if (chip.dataset.category === filterCat) {
          chip.style.display = '';
        } else {
          chip.style.display = 'none';
        }
      });
    });
  });

  const mOverlay = document.getElementById('halo-modal-overlay');
  const title = document.getElementById('halo-modal-title');
  const desc = document.getElementById('halo-modal-desc');
  const icon = document.getElementById('halo-modal-icon');
  const hlList = document.getElementById('halo-modal-highlights');
  
  allChips.forEach(chip => {
    chip.addEventListener('click', function() {
      const data = featureDetails[this.dataset.feature];
      if (data && mOverlay) {
        title.textContent = data.title;
        desc.textContent = data.description;
        icon.innerHTML = '';
        icon.appendChild(this.querySelector('svg').cloneNode(true));
        
        hlList.innerHTML = '';
        if (data.highlights) {
          document.getElementById('halo-modal-divider').style.display = 'block';
          data.highlights.forEach(h => {
            const li = document.createElement('li');
            li.textContent = '• ' + h;
            hlList.appendChild(li);
          });
        } else {
          document.getElementById('halo-modal-divider').style.display = 'none';
        }
        
        mOverlay.style.display = 'flex';
        void mOverlay.offsetWidth;
        mOverlay.classList.add('visible');
      }
    });
  });

  function closeM() {
    if (mOverlay) {
      mOverlay.classList.remove('visible');
      setTimeout(() => mOverlay.style.display = 'none', 300);
    }
  }
  document.getElementById('halo-modal-close')?.addEventListener('click', closeM);
  mOverlay?.addEventListener('click', e => { if (e.target === mOverlay) closeM(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeM(); });

  if (bannerBuyBtn && section) {
    bannerBuyBtn.addEventListener('click', () => section.scrollIntoView({ behavior: 'smooth' }));
  }

  // Sticky bar → reuse the final CTA's real Add-to-Cart (same AJAX behaviour)
  if (stickyBtn) {
    stickyBtn.addEventListener('click', () => {
      // Final CTA is its own section now and may be reordered or removed.
      if (finalBtn) { finalBtn.click(); return; }
      const mainForm = document.querySelector('#product-section form[action*="/cart/add"]');
      if (mainForm) mainForm.requestSubmit ? mainForm.requestSubmit() : mainForm.submit();
    });
  }

  // Show the sticky bar once the main Add-to-Cart has scrolled off,
  // and hide it again once the final CTA comes into view.
  const mainBuyBtn = document.getElementById('halo-buy-btn');
  if (stickyBar && mainBuyBtn) {
    const onScroll = () => {
      const pastMainBuy = mainBuyBtn.getBoundingClientRect().bottom < 0;
      const finalInView = finalSection
        ? finalSection.getBoundingClientRect().top < window.innerHeight - 80
        : false;
      if (pastMainBuy && !finalInView) stickyBar.classList.add('visible');
      else stickyBar.classList.remove('visible');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }
});
})();
